import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { captureException } from '@sentry/react-router';

import { type MostPopularBetsIndexProps } from '@cx-modules/most-popular-bets';
import MostPopularBetsWithQuery from '@cx-modules/most-popular-bets';

export const MostPopularBets = (props: Omit<MostPopularBetsIndexProps, 'i18n'>) => {
  const { i18n } = useTranslation();

  return (
    <ErrorBoundary
      fallbackRender={({ error }) => {
        captureException(error);
        return null;
      }}
    >
      <MostPopularBetsWithQuery {...props} i18n={i18n} />
    </ErrorBoundary>
  );
};
